import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import CustomInput from '../../components/customInput/CustomInput';
import CustomDatePicker from '../customDatePicker/CustomDatePicker';
import CustomMultiSelect from '../../components/customMultiSelect/CustomMultiSelect';

const AddUploadForm = ({
  onSearchParamsChange,
  searchParams,
  showSelects = false,
  singtelOptions = [],
  shopOptions = []
}) => {
  const { sku, promoDate, selectedSingtel, selectedShop } = searchParams;

  const inputStyle = {
    width: '210px',
    height: '45px',
    marginRight: '20px',
    boxSizing: 'border-box',
    outline: 'none',
  };

  const selectStyle = {
    ...inputStyle,

  };

  return (
    <div style={{ display: 'flex', marginTop: '35px' }}>
      <div>
        <CustomInput
          type="text"
          placeholder="Enter SKU"
          value={sku}
          onChange={(e) => onSearchParamsChange('sku', e.target.value)}
          style={inputStyle}
        />
      </div>

      {showSelects && (
        <>
          <div>
            <CustomMultiSelect
              options={singtelOptions}
              placeholder="Select Singtel shop(s)"
              selectedValues={selectedSingtel || []}
              onChange={(values) => onSearchParamsChange('selectedSingtel', values)}
              style={selectStyle}
            />
          </div>
          <div>
            <CustomMultiSelect
              options={shopOptions}
              placeholder="Select SER shop(s)"
              selectedValues={selectedShop || []}
              onChange={(values) => onSearchParamsChange('selectedShop', values)}
              style={selectStyle}
            />
          </div>
        </>
      )}

      <div>
        <CustomDatePicker
          value={promoDate}
          onChange={(date) => onSearchParamsChange('promoDate', date)}
          placeholderText="Select Promo Date"
          showIcon
          dateFormat="yyyy-MM-dd"
          className="datepicker-right-icon"
          customInput={<input style={inputStyle} />}
        />
      </div>
    </div>
  );
};


export default AddUploadForm;    